import {IPagedList} from "@renta-apps/athenaeum-toolkit";
import {PostAsync} from "@/types/PostAsync";
import GetWorkOrderCreationRequestsRequest from "@/models/server/requests/GetWorkOrderCreationRequestsRequest";
import WorkOrderCreationRequestModel from "@/models/server/WorkOrderCreationRequestModel";

/**
 * {@link WorkOrderCreationRequestModel} provider
 */
class WorkOrderCreationRequestProvider {

    public async getWorkOrderCreationRequestsPagedListAsync(sender: PostAsync<GetWorkOrderCreationRequestsRequest, IPagedList<WorkOrderCreationRequestModel>>, request: Readonly<GetWorkOrderCreationRequestsRequest>): Promise<IPagedList<WorkOrderCreationRequestModel>> {
        return await sender.postAsync("/api/workOrderCreationRequest/getWorkOrderCreationRequestsPagedList", request);
    }

    public async getWorkOrderCreationRequestAsync(sender: PostAsync<string, WorkOrderCreationRequestModel>, id: string): Promise<WorkOrderCreationRequestModel> {
        return await sender.postAsync("/api/workOrderCreationRequest/getWorkOrderCreationRequest", id);
    }

    public async processWorkOrderCreationRequestAsync(sender: PostAsync<string, void>, id: string): Promise<void> {
        return await sender.postAsync("/api/workOrderCreationRequest/processWorkOrderCreationRequest", id);
    }

    public async deleteWorkOrderCreationRequestAsync(sender: PostAsync<string, void>, id: string): Promise<void> {
        return await sender.postAsync("/api/workOrderCreationRequest/deleteWorkOrderCreationRequest", id);
    }

    public async restoreWorkOrderCreationRequestAsync(sender: PostAsync<string, void>, id: string): Promise<void> {
        return await sender.postAsync("/api/workOrderCreationRequest/restoreWorkOrderCreationRequest", id);
    }
}

/**
 * {@link WorkOrderCreationRequestProvider} singleton
 */
export default new WorkOrderCreationRequestProvider();